(function () {
  if (window.threeDMarkAddonCartGuardLoaded) return;
  window.threeDMarkAddonCartGuardLoaded = true;

  function getCartUrl() {
    if (window.theme && theme.routes && theme.routes.cart) {
      return theme.routes.cart.replace(/\/$/, '');
    }

    return '/cart';
  }

  function getCartJsonUrl() {
    return `${getCartUrl()}.js`;
  }

  function getCartUpdateUrl() {
    return `${getCartUrl()}/update.js`;
  }

  function fetchCart() {
    return fetch(getCartJsonUrl(), {
      headers: {
        Accept: 'application/json'
      }
    }).then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    });
  }

  function updateCart(updates) {
    if (!updates || Object.keys(updates).length === 0) {
      return Promise.resolve(null);
    }

    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates })
    }).then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    });
  }

  function getDomRow(item) {
    if (!window.CSS || !CSS.escape || !item || !item.key) return null;

    return document.querySelector(`[data-line-key="${CSS.escape(item.key)}"]`);
  }

  function getItemProperty(item, key) {
    if (!item) return '';

if (item.properties) {
  if (item.properties[key]) {
    return item.properties[key];
  }

  if (key === '_parent_line_key' && item.properties['Parent line key']) {
    return item.properties['Parent line key'];
  }

  if (key === '_parent_product_id' && item.properties['Parent product id']) {
    return item.properties['Parent product id'];
  }

  if (key === '_parent_variant_id' && item.properties['Parent variant id']) {
    return item.properties['Parent variant id'];
  }

  if (key === '_addon_variant_id' && item.properties['Addon variant id']) {
    return item.properties['Addon variant id'];
  }

  if (key === '_addon_group' && item.properties['Addon group']) {
    return item.properties['Addon group'];
  }
}

    const row = getDomRow(item);

    if (!row) return '';

    if (key === '_parent_line_key') {
      return row.dataset.addonParentLineKey || '';
    }

    if (key === '_parent_product_id') {
      return row.dataset.addonParentProductId || '';
    }

    if (key === '_parent_variant_id') {
      return row.dataset.addonParentVariantId || '';
    }

    if (key === '_addon_group') {
      return row.dataset.addonGroup || '';
    }

    if (key === '_addon_only') {
      return row.dataset.addonOnly === 'true' ? 'true' : '';
    }

    return '';
  }

  function isAddonByProperty(item) {
    return getItemProperty(item, '_addon_only') === 'true';
  }

  function isAddonByDom(item) {
    const row = getDomRow(item);

    return Boolean(row && row.dataset.addonOnly === 'true');
  }

  function isAddonItem(item) {
    return isAddonByProperty(item) || isAddonByDom(item);
  }

  function getParentLineKey(item) {
    return String(getItemProperty(item, '_parent_line_key') || '');
  }

  function getParentVariantId(item) {
    return String(getItemProperty(item, '_parent_variant_id') || '');
  }

  function getParentProductId(item) {
    return String(getItemProperty(item, '_parent_product_id') || '');
  }

  function getAddonGroup(item) {
    return String(getItemProperty(item, '_addon_group') || '');
  }

  function getAddonGroupKey(item) {
    const addonGroup = getAddonGroup(item);
    const addonVariantId = String(item.variant_id || '');
    const parentLineKey = getParentLineKey(item);
    const parentProductId = getParentProductId(item);
    const parentVariantId = getParentVariantId(item);

    if (addonGroup) {
      return addonGroup;
    }

    if (parentLineKey) {
      return `${parentLineKey}-${addonVariantId}`;
    }

    if (parentProductId && parentVariantId) {
      return `${parentProductId}-${parentVariantId}-${addonVariantId}`;
    }

    if (parentVariantId) {
      return `${parentVariantId}-${addonVariantId}`;
    }

    if (parentProductId) {
      return `${parentProductId}-${addonVariantId}`;
    }

    return `no-parent-${addonVariantId}`;
  }

  function hasAnyParentData(item) {
    return Boolean(
      getParentLineKey(item) ||
      getParentVariantId(item) ||
      getParentProductId(item)
    );
  }

  function findParentItem(addonItem, mainItems) {
    const parentLineKey = getParentLineKey(addonItem);
    const parentVariantId = getParentVariantId(addonItem);
    const parentProductId = getParentProductId(addonItem);

    /**
     * 新版資料最重要：
     * 如果有 _parent_line_key，就只用 line key 找。
     * 找不到代表那一筆主商品已經不存在。
     */
    if (parentLineKey) {
      return mainItems.find((mainItem) => {
        return String(mainItem.key) === parentLineKey;
      }) || null;
    }

    /**
     * 舊資料 fallback：
     * 只有沒有 _parent_line_key 時，才允許用 variant / product 找。
     */
    if (parentVariantId) {
      const parentByVariantId = mainItems.find((mainItem) => {
        return String(mainItem.variant_id) === parentVariantId;
      });

      if (parentByVariantId) return parentByVariantId;
    }

    if (parentProductId) {
      const parentByProductId = mainItems.find((mainItem) => {
        return String(mainItem.product_id) === parentProductId;
      });

      if (parentByProductId) return parentByProductId;
    }

    return null;
  }

  async function guardAddonCart(options = {}) {
    try {
      /**
       * 剛加入商品時不要清理。
       * 但刪除主商品 / 修改數量時會帶 ignorePause: true，必須照常執行。
       */
      if (
        !options.ignorePause &&
        window.threeDMarkAddonCartGuardPausedUntil &&
        Date.now() < window.threeDMarkAddonCartGuardPausedUntil
      ) {
        return false;
      }

      const cart = await fetchCart();
      const updates = {};
      const seenGroups = new Set();

      const addonItems = cart.items.filter(isAddonItem);
      const mainItems = cart.items.filter((item) => !isAddonItem(item));

      addonItems.forEach((addonItem) => {
        const groupKey = getAddonGroupKey(addonItem);
        const parentItem = findParentItem(addonItem, mainItems);
        const hasParentData = hasAnyParentData(addonItem);

        /**
         * 情況 1：
         * 購物車沒有任何主商品，只剩加購品，移除。
         */
        if (mainItems.length === 0) {
          updates[addonItem.key] = 0;
          return;
        }

        /**
         * 情況 2：
         * 加購品有 parent 資料，但找不到對應主商品。
         * 代表該主商品已經被刪除，要移除對應加購品。
         */
        if (hasParentData && !parentItem) {
          updates[addonItem.key] = 0;
          return;
        }

        /**
         * 情況 3：
         * 完全沒有 parent 資料時，先不刪。
         * 避免舊資料或剛加入時 properties 還沒同步造成誤刪。
         */
        if (!hasParentData) {
          return;
        }

        /**
         * 情況 4：
         * 同一個主商品底下，同一個加購品只保留一筆。
         * 不同主商品 / 不同規格的同一個加購品可以共存。
         */
        if (seenGroups.has(groupKey)) {
          updates[addonItem.key] = 0;
          return;
        }

        seenGroups.add(groupKey);

        /**
         * 情況 5：
         * 加購品數量最多不能超過對應主商品數量，但可以少於主商品。
         *
         * 主商品 2，加購品 1：允許
         * 主商品 2，加購品 2：允許
         * 主商品 2，加購品 3：自動降成 2
         */
        if (parentItem && addonItem.quantity > parentItem.quantity) {
          updates[addonItem.key] = parentItem.quantity;
        }
      });

      if (Object.keys(updates).length === 0) return false;

      await updateCart(updates);

      if (options.refresh !== false) {
        refreshCartUI();
      }

      return true;
    } catch (error) {
      console.warn('[3DMARK ADDON CART GUARD] failed:', error);
      return false;
    }
  }

  function refreshCartUI() {
    const cartUrl = getCartUrl();
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const isCartPage = currentPath === cartUrl;

    const cartDrawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');

    if (cartDrawer && typeof cartDrawer.refresh === 'function' && !isCartPage) {
      cartDrawer.refresh(true);
      return;
    }

    if (cartItems && typeof cartItems.refresh === 'function' && !isCartPage) {
      cartItems.refresh();
      return;
    }

    if (isCartPage) {
      window.location.reload();
    }
  }

  let guardTimer = null;

  function scheduleGuard(delayMs, options = {}) {
    clearTimeout(guardTimer);

    guardTimer = setTimeout(() => {
      guardAddonCart(options);
    }, delayMs || 2000);
  }

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      guardAddonCart();
    }, 3000);
  });

  /**
   * 刪除商品時，必須 ignorePause。
   * 不然剛加入後 10 秒內刪主商品，加購品不會被處理。
   */
  document.addEventListener('click', (event) => {
    if (
      event.target.closest('.js-remove-item') ||
      event.target.closest('cart-remove-button') ||
      event.target.closest('[href*="/cart/change"]')
    ) {
      scheduleGuard(1200, { ignorePause: true });

      setTimeout(() => {
        guardAddonCart({ ignorePause: true });
      }, 2500);
    }
  });

  /**
   * cart-items.js 更新主商品數量後會發這個事件。
   * 修改數量也必須 ignorePause。
   */
  document.addEventListener('3dmark:addon-cart-check', () => {
    scheduleGuard(1200, { ignorePause: true });
  });

  document.addEventListener('cart:updated', () => {
    scheduleGuard(2500);
  });

  document.addEventListener('on:cart:add', () => {
    scheduleGuard(7000);
  });

  document.addEventListener('on:line-item:change', () => {
    scheduleGuard(1200, { ignorePause: true });
  });

  window.threeDMarkAddonCartGuard = guardAddonCart;
})();